import Alpine from "alpinejs";

Alpine.store('modal', {
    currentModal: null,
    justOpened: false,
    orderId: null,

    init() {
        const query = new URLSearchParams(window.location.search);
        if (query.get('modal')) {
            this.open(query.get('modal'));
        }
        if (query.get('order')) {
            this.orderId = query.get('order');
        }
    },

    clearQuery() {
        window.location.search = '';
    },

    open(modalName) {
        if (this.currentModal !== null) window.dispatchEvent(new Event('modal-close'));
        this.currentModal = modalName;
        this.justOpened = true;
        document.querySelector('body').classList.add('app--fix');

        setTimeout(() => {
            this.justOpened = false;
        }, 10);
    },

    isOpen(modalName) {
        return this.currentModal === modalName;
    },

    close() {
        this.currentModal = null;
        window.dispatchEvent(new Event('modal-close'));
        document.querySelector('body').classList.remove('app--fix');
    },

    toggle(modalName) {
        if (this.isOpen(modalName)) {
            this.close();
        } else {
            this.open(modalName);
        }
    },

    handleOutsideClick(modalName) {
        if (this.justOpened) {
            return;
        }
        if (this.isOpen(modalName)) {
            this.close();
            window.dispatchEvent(new Event('modal-close'));
        }
    }
});
